/*
 * @Author: Dzy
 * @Date: 2022-07-18 11:13:54
 * @LastEditors: Dzy
 * @LastEditTime: 2022-11-16 10:38:03
 * @Description: 登录鉴权功能模块
 */
import { checkResult } from '@/utils/tools'
import { useRequest } from 'vue-request'
import { request } from '@/utils/request.js'

export default () => {
  const {
    data: resultSimpleInfo,
    runAsync: runSimpleInfo,
    loading
  } = useRequest((payload) => request('/api/oper/web/cs/tenantOrg/getSimpleInfo', payload))

  const loadSimpleInfo = async () => {
    await runSimpleInfo()
    if (checkResult(resultSimpleInfo.value) && resultSimpleInfo.value.data) {
      return resultSimpleInfo.value.data
    } else {
      return null
    }
  }

  return {
    loadSimpleInfo
  }
}
